import { render } from "./CodingSimulationPanel.vue?vue&type=template&id=2e999c37&scoped=true"
import script from "./CodingSimulationPanel.vue?vue&type=script&lang=js"
export * from "./CodingSimulationPanel.vue?vue&type=script&lang=js"

import "./CodingSimulationPanel.vue?vue&type=style&index=0&id=2e999c37&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/c2stem-server-spice/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e999c37"]])

export default __exports__